"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sliderThumb = _interopRequireDefault(require("./slider-thumb"));
const _excluded = ["thumbs", "autoHide"];
/**
 * Returns array of thumbs with appropriate position and event handlers.
 * @param {React.PropsWithoutRef} props components props
 * @returns {React.ReactElement[]} Array of rendered thumbs
 * @private
 */
function SliderThumbs(_ref) {
  let {
      thumbs,
      autoHide: autoHideValue
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return thumbs.map((val, index) => {
    return /*#__PURE__*/_react.default.createElement(_sliderThumb.default, (0, _extends2.default)({
      key: `${props.id}-${index}`,
      value: val,
      index: index,
      autoHideValue: autoHideValue
    }, props));
  });
}
SliderThumbs.propTypes = {
  dir: _propTypes.default.string,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  renderWidth: _propTypes.default.number,
  thumbs: _propTypes.default.array,
  id: _propTypes.default.string,
  sliderRef: _propTypes.default.object,
  autoHide: _propTypes.default.number,
  setValueLabels: _propTypes.default.func,
  setValue: _propTypes.default.func,
  range: _propTypes.default.bool,
  shouldRenderLabels: _propTypes.default.bool,
  step: _propTypes.default.number,
  minRangeStep: _propTypes.default.number,
  allowClickUpdate: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  /** Screenreader labels for sub-elements */
  ariaLabels: _propTypes.default.string
};
var _default = exports.default = SliderThumbs;